"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { UI } from "@/constants";
import { getWeekNumber } from "@/lib";
import { OrderType } from "@/types";
import { Bar, BarChart, LabelList, XAxis } from "recharts";

const chartConfig = {
  sharedProductsTotal: {
    label: UI.labels.sharedProductsTotal,
    color: "var(--chart-3)",
  },
  productsTotal: {
    label: UI.labels.productsTotal,
    color: "var(--chart-5)",
  },
} satisfies ChartConfig;

const bars = [
  { key: "sharedProductsTotal", color: "var(--color-sharedProductsTotal)" },
  { key: "productsTotal", color: "var(--color-productsTotal)" },
];

type UserOrdersChartProps = {
  orders: OrderType[];
};

export const UserOrdersChart = ({ orders }: UserOrdersChartProps) => {
  if (!orders.length) return null;
  const limitedOrders = orders.slice(0, Number(UI.options.size[1]));

  return (
    <ChartContainer config={chartConfig} className="chart-container">
      <BarChart accessibilityLayer data={limitedOrders} margin={{ top: 24 }}>
        <XAxis
          dataKey="weekNumber"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          minTickGap={32}
          tickFormatter={value => `${getWeekNumber(value)} ${UI.labels.week}`}
        />
        <ChartTooltip
          content={
            <ChartTooltipContent
              className="w-52"
              indicator="line"
              labelFormatter={value => `${getWeekNumber(value)} ${UI.labels.week}`}
            />
          }
        />
        <ChartLegend content={<ChartLegendContent />} />
        {bars.map(({ key, color }) => (
          <Bar key={key} dataKey={key} fill={color} radius={4}>
            <LabelList position="top" offset={12} className="fill-foreground" fontSize={12} />
          </Bar>
        ))}
      </BarChart>
    </ChartContainer>
  );
};
